<template>
   <div class="layout-page">
      <h1>Agents</h1>
      <div class="container-fluid">
         <div class="row marb-12">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-4 text-right">
               <hier-ddl 
                  :hierarchies="filteredHierarchies" 
                  :selectedHierarchy="selectedHierarchy"
                  :showBlocks="false"
                  :healthBlockNumbers ="healthBlockNumbers"
                  @hier-changed="hierarchyChanged"
               ></hier-ddl>
            </div>
         </div>
      </div>
      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-10 tab-box">
               <div v-if="showRequestToMove" class="req-link font-smaller">
                  <router-link to="/svcreq/SVCREQ_LEVELCHG" v-tooltip:Left="'Send a request to EasyAppoint admins to change levels or hierarchies for a particular agent'">
                     <i class="fas fa-paper-plane"></i>
                     Request that an Agent be Moved
                  </router-link>
               </div>
               <!-- Nav tabs -->
               <ul class="nav nav-tabs">
                  <li class="nav-item">
                     <a class="nav-link active" data-toggle="tab" href="#tree" id="tree_tab" v-tooltip:Right="'View agent downline'">ACTIVE AGENTS</a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link" data-toggle="tab" href="#search" id="search_tab" v-tooltip:Right="'Search for agents in your downline'">SEARCH</a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link" data-toggle="tab" href="#inactive" id="inactive_tab" v-tooltip:Right="'View recently deactivated agents'">DEACTIVATED</a>
                  </li>
               </ul>
               <div class="tab-content">
                  
                  <!-- T R E E -->
                  <div id="tree" class="tab-pane fade show active" v-cloak>
                     <div class="b-card">
                        <div class="card-header bg-transparent">
                           <div class="reset-link">
                              <a href="#" @click.prevent="runFetchStart" v-tooltip:Left="'Refresh the tree starting with the logged in agency'">
                                 <i class="fas fa-sync"></i>
                                 RESET
                              </a>
                           </div>
                           <i class="fi-creative-users"></i>
                           <span class="card-label">Active Agents</span> 
                        </div>
                        <div class="card-body">
                           <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="searching"></i>
                           <div v-else>
                                <!-- Nav tabs -->
                              <ul class="nav nav-tabs" >
                                 <li class="nav-item" v-if="showMiacHealthTab" >
                                    <a v-on:click="handleCarrierTabClicked('MIAC')" class="nav-link active" data-toggle="tab" href="#miacHealthTab" id="miac_health_tab" v-tooltip:Right="'MIAC Health Hierarchy'">MIAC HEALTH</a>
                                 </li>
                                 <li class="nav-item" v-if="showSlacHealthTab" >
                                    <a  v-on:click="handleCarrierTabClicked('SLAC')" v-bind:class="(activateShowHierarchyCarrierTab('SLAC'))? 'nav-link active' : 'nav-link'" data-toggle="tab" href="#slacHealthTab"  id="slac_health_tab" v-tooltip:Right="'SLAC Health Hierarchy'">SLAC HEALTH</a>
                                 </li>
                                 <li class="nav-item active" v-if="showSlacLifeTab" >
                                    <a  v-on:click="handleCarrierTabClicked('SLAC')" v-bind:class="(activateShowHierarchyCarrierTab('SLAC'))? 'nav-link active' : 'nav-link'" data-toggle="tab" href="#slacLifeTab"  id="slac_life_tab" v-tooltip:Right="'SLAC Life Hierarchy'">SLAC LIFE</a>
                                 </li>
                              </ul>
                              <div class="tab-content" v-if="showActiveAgentsTabContent()">
                                 <div id="miacHealthTab" v-if="showMiacHealthTab" class="tab-pane fade show active" >
                                    <tree 
                                       :treeitem="records"
                                       :pageSize="pageSize"
                                       :selected="selected"
                                       :enableAppointLink=true
                                       @node-click="treeItemClicked"
                                       @more-click="moreItemsClicked"
                                       @link-click="linkItemClicked"
                                    >
                                    </tree>
                                 </div>
                                 <div id="slacHealthTab"  v-if="showSlacHealthTab" v-bind:class="(activateShowHierarchyCarrierTab('SLAC'))? 'tab-pane show active' : 'tab-pane fade'" >
                                    <tree v-if="showSlacHealthTab"
                                       :treeitem="records"
                                       :pageSize="pageSize"
                                       :selected="selected"
                                       :enableAppointLink=true
                                       @node-click="treeItemClicked"
                                       @more-click="moreItemsClicked"
                                       @link-click="linkItemClicked"
                                    >
                                    </tree>
                                 </div>
                                 <div id="slacLifeTab"  v-if="showSlacLifeTab" v-bind:class="(activateShowHierarchyCarrierTab('SLAC'))? 'tab-pane show active' : 'tab-pane fade'" >
                                    <tree v-if="showSlacLifeTab"
                                       :treeitem="records"
                                       :pageSize="pageSize"
                                       :selected="selected"
                                       :enableAppointLink=true
                                       @node-click="treeItemClicked"
                                       @more-click="moreItemsClicked"
                                       @link-click="linkItemClicked"
                                    >
                                    </tree>
                                 </div>
                              </div>
                              <div v-else class="text-danger font-smaller">
                                 {{ noDataMsg }}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- S E A R C H -->
                  <div id="search" class="tab-pane fade">
                     <c-agent 
                        :criteria="criteria" 
                        @crit-change="criteriaChange" 
                        @search-clicked="searchButton" 
                        :searching="searching"></c-agent>

                     <div v-if="showResults">
                        <div class="b-card">
                           <div class="card-header bg-transparent">
                              <i class="fi-creative-users"></i>
                              <span class="card-label">Agent Downline Search Results</span> 
                           </div>
                           <div class="card-body">
                              <div class="font-smaller" v-if="searchHasData()">
                                 <data-grid 
                                       :headers="searchHeaders" 
                                       :records="searchResults" 
                                       :rowsPerPage="searchPageSize" 
                                       :currentPage="searchPage" 
                                       :totalRecords="searchTotalRecs" 
                                       :clickHandler="searchGridClickHandler"
                                       :navHandler="searchGridNavHandler"
                                       :noDataMsg="noDataMsg"
                                       :clickHierarchy="searchGridHierHandler"
                                       @page-size-changed="searchPageChanged">
                                 </data-grid>
                              </div>
                              <div class="text-danger" v-if="!searchHasData()">
                                 {{ noDataMsg }}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- Deactivated -->
                  <div id="inactive" class="tab-pane fade" v-cloak>
                     <div class="b-card">
                        <div class="card-header bg-transparent">
                           <i class="fi-creative-users"></i>
                           <span class="card-label">Deactivated Agents</span> 
                        </div>
                        <div class="card-body">
                           <div class="font-smaller">
                              <data-grid 
                                    :headers="deactHeaders" 
                                    :records="deactAgents" 
                                    :rowsPerPage="deactPageSize" 
                                    :currentPage="deactPage" 
                                    :totalRecords="deactTotalRecs" 
                                    :navHandler="deactGridNavHandler"
                                    :noDataMsg="noDataMsg"
                                    @page-size-changed="deactPageChanged">
                              </data-grid>
                              <span class="text-muted font-smaller">(over the last 12 months)</span>
                           </div>
                        </div>
                     </div>   
                  </div>

               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import 'bootstrap'
import $ from 'jquery'
import Tree from '../components/tree.vue'
import AgentCriteria from '../components/AgentC.vue'
import DataGrid from "@/components/datagrid.vue"
import hierDDL from "@/components/hierarchyDDL.vue"

export default {
    components: {
        'tree': Tree,
        'c-agent': AgentCriteria,
        'data-grid': DataGrid,
        'hier-ddl': hierDDL
    },
    data() {
        return {
            showRequestToMove: false,
            // tree control
            selected: {},
            records: {},
            miacHealthTreeData: [],
            slacHealthTreeData: [],
            slacLifeTreeData: [],
            hierarchies: [],
            filteredHierarchies: [],
            blockNumbers: [],
            healthBlockNumbers: [],
            lifeBlockNumbers: [],
            selectedHierarchy: null,
            showSlacHealthTab: false,
            showMiacHealthTab: false,
            showSlacLifeTab: false,
            selectedCarrier: "",
            page: 1,
            pageSize: 50,
            nameFilter: '',
            criteria: '',
            searching: false,
            selAgentLevel: 0,

            // search results grid
            searchResults: [],
            searchPage: 0,
            searchPageSize: 10,
            showResults: false,
            searchTotalRecs: 0,
            searchHeaders: [
               {
                  name: "agentNumber",
                  label: "Agent #",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "lastName",
                  label: "Last Name",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "firstName",
                  label: "First Name",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "companyName",
                  label: "Company Name",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "hierarchyLevel",
                  label: "Level",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "__ACTION",
                  label: "",
                  sortable: false,
                  isdate: false,
                  ismoney: false,
                  tt: 'Agent Details'
               },
               {
                  name: "__HIER",
                  label: "",
                  sortable: false,
                  isdate: false,
                  ismoney: false,
                  tt: 'Hierarchy'
               }
            ],
            noDataMsg: 'No data found. Please Search again...',

            // deactivated user grid
            deactCriteria: {},
            deactAgents: [],
            deactPageSize: 10,
            deactPage: 0, // ZER0 BASED paging
            deactTotalRecs: 0,
            deactHeaders: [
               {
                  name: "fullName",
                  label: "Full Name",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "agentNumber",
                  label: "Agent #",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "companyNumber",
                  label: "Company Number",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "blockNumber",
                  label: "Block Number",
                  sortable: true,
                  isdate: false,
                  ismoney: false
               },
               {
                  name: "terminationDate",
                  label: "Terminated",
                  sortable: false,
                  isdate: true,
                  ismoney: false
               },
               
            ]
        }
    },
    computed: {
        datafound() {
            return (this.records != {} && !this.isEmpty(this.records))
        },
        deactTotalPages() {
            return this.deactHasData ? Math.trunc(this.deactTotalRecs / this.deactPageSize) + (this.deactTotalRecs % this.deactPageSize > 0 ? 1 : 0) : 0
        },
        searchTotalPages() {
           return this.searchHasData ? Math.trunc(this.searchTotalRecs / this.searchPageSize) + (this.searchTotalRecs % this.searchPageSize > 0 ? 1 : 0) : 0
        }
    },
    created() {
        this.initialize()
    },
    mounted() {
    },
    methods: {
        async initialize() {
            // Load hierarchies
            this.$parent.loadingStart()
            this.searching = true
            await this.loadBlockNumbers();
            this.hierarchies = this.$store.getters.hierarchies

            if (!this.hierarchies || this.hierarchies.length < 1) {
               await this.$store.dispatch("getHierarchies")
               this.hierarchies = this.$store.getters.hierarchies
            }
            if (this.hierarchies && this.hierarchies.length > 0) {
               this.selectedHierarchy = this.hierarchies[0]
            }

            if (this.$route.params.agentNumber === undefined ||
               this.$route.params.agentNumber == this.selectedHierarchy.agentNo || 
               this.$route.params.directUpline.trim() == '0000' || 
               this.$route.params.directUpline.trim() == '') 
            {
               if (this.hierarchies && this.hierarchies.length > 0) {                  
                  if (this.$route.params.hier != null) {
                     this.selectedHierarchy = this.$route.params.hier
                  }                  
                  await this.fetchStart()
                  await this.getDeactivated()
               }
            } else {
               await this.getDeactivated()
               await this.remoteHierarchy()
            }
            this.filterHierarchies()
            this.searching = false
            this.setHierarchyShowTabs()
            this.$parent.loadingEnd()
        },
        filterHierarchies()
        {
            this.hierarchies.forEach((h) => 
               {
                  var agentNumber = h.agentNo
                  if(this.isHealthBlock(h.blockNo))
                  {
                     //check if the agentNumber health already exists in the filteredHierarchy
                     if(this.filteredHierarchies.length > 0)
                     {
                        if( !this.filteredHierarchies.some((fh) => 
                             fh.agentNo === agentNumber && this.isHealthBlock(fh.blockNo)
                             )
                        ){
                           this.filteredHierarchies.push(h)
                        }
                     }
                     else {
                        this.filteredHierarchies.push(h)
                     }
                  }
                  else {
                     if(this.filteredHierarchies.length > 0)
                     {
                        //check if the agentNumber life already exists in the filteredHierarchy
                        if( !this.filteredHierarchies.some((fh) => 
                                 fh.agentNo === agentNumber && !this.isHealthBlock(fh.blockNo)
                              )
                           ){

                              this.filteredHierarchies.push(h)
                           }
                     }
                     else {
                        this.filteredHierarchies.push(h)
                     }
                  }
               }
            )

            this.selectedHierarchy = this.filteredHierarchies[0]
            this.selectedCarrier = this.selectedHierarchy.carrier

        },
        async loadBlockNumbers()
        {
            await this.$agent.getBlockNumbers()
            .then((r) => {
                  if (r) {
                     this.blockNumber = r.blockNumbers
                     this.healthBlockNumbers = r.healthBlockNumbers
                     this.lifeBlockNumbers = r.lifeBlockNumbers
                  }
               })
               .catch((err) => {
                  // log err 
                  this.$swal(
                     "Error Retrieving Carrier Block information",
                     "Please contact support",
                     "error"
                  );
               })
        },
        isHealthBlock(block)
        {
            return this.healthBlockNumbers.some((b) => b === block)
        },
        goToAgentDetail(agt) {
           this.$router.push({ name: 'agent', params: agt })
        },
        criteriaChange( newCrit ) {
            this.showResults = false
            this.criteria = newCrit
        },
        distinct(items) {
           let rslt = []
           items.forEach((item, index) => {
              if (!rslt.find((itm) => {
                 return (itm.carrier == item.carrier && itm.mgaCode == item.mgaCode && itm.agentNo == item.agentNo)
              })) {
                 rslt.push(item)
              } 
           })
           return rslt;
        },
        treeItemClicked(node) {
           let nodeLevel = parseInt(node.hierarchyLevel)
           if (nodeLevel < this.selAgentLevel) {
              this.$swal(
                  "Details Unavailable",
                  "Details are only available for the current user's downline.",
                  "warning"
               );
              return
           }
           this.setPayloadCallGoToAgentDetail(node)
        },
        setPayloadCallGoToAgentDetail(node)
        {
            let agt = {
               agentNumber: node.agentNumber,
               blockNumber: node.blockNumber,
               companyName: node.companyName,
               companyNumber: node.companyNumber,
               directUpline: node.directUpline,
               firstName:  node.firstName,
               mgaCode: node.mgaCode,
               hierarchyLevel: node.hierarchyLevel,
               lastName: node.lastName,
               topAgentNum: this.selectedHierarchy.agentNo
            }
            this.goToAgentDetail(agt);
        },
        async getDeactivated() {
            // Get the starting data for the hierarchy
            if (this.selectedHierarchy != null) {
               
               let s = this.selectedHierarchy
               let payload = {
                  AgentNumber : s.agentNo,
                  CompanyNumber : s.companyNo,
                  BlockNumber : s.blockNo,
                  PageSize : this.deactPageSize,
                  PageNumber : this.deactPage,
                  ParentLevels : 0,
                  ChildLevels : 0
               }

               await this.$agent.getDeactivated(payload)
               .then((r) => {
                  if (r && r.length > 0) {
                     this.deactTotalRecs = r[0].recordCount
                     this.$set(this, 'deactAgents', r)
                  }
               })
               .catch((err) => {
                  // log err 
               })
            }
        },
        async moreItemsClicked(node) {
            this.$parent.loadingStart()

            let payload = {
               AgentNumber : node.agentNumber,
               CompanyNumber : node.companyNumber, 
               BlockNumber : node.blockNumber,
               PageSize : this.pageSize,
               PageNumber : node.childPage + 1,
               ParentLevels : 0,
               ChildLevels : 1,
               NameFilter: this.nameFilter
            }

            await this.$agent.getTreeChildren(payload)
            .then((r) => {
               node.childPage += 1
               if (r && r.length > 0) {
                  if (node.children == null) {
                     this.$set(node, 'children', [])
                  }
                  r.forEach((itm,indx) => {
                     node.children.push(itm)
                  })
               }
               this.nameFilter = ''
               this.$parent.loadingEnd()
            })
            .catch((err) => {
               this.$parent.loadingEnd()
            })
        },
        linkItemClicked(node) {
           let parms = {
              agentNumber: node.agentNumber,
              companyNumber: node.companyNumber,
              blockNumber: node.blockNumber,
              mgaCode: node.mgaCode,
              useLocalStorage: false
           }
           this.$router.push({ name: 'cartlinks',params: parms})
        },
        searchButton() {
           this.searchPage = 0
           this.search()
        },
        async search() {
           if (this.selectedHierarchy == null || this.selectedHierarchy == {}) return
           if (!this.criteria || (this.criteria.lastname.trim() + 
               this.criteria.firstname.trim() + 
               this.criteria.agentnumber.trim() + 
               this.criteria.companyname.trim()).length < 1) {
               this.$swal(
                  "Search for What?",
                  "Please enter some search criteria before searching.",
                  "error"
               );
              return
           }
           let h = this.selectedHierarchy
           this.searching = true;
           this.showResults = false;

           let payload = {
              parentAgentNumber: h.agentNo,
              parentCompanyNumber: h.companyNo,
              parentBlockNumber: h.blockNo,
              lastName: this.criteria.lastname,
              firstName: this.criteria.firstname,
              agentNumber: this.criteria.agentnumber,
              companyName: this.criteria.companyname,
              pageSize: this.searchPageSize,
              page: this.searchPage + 1
           }

           await this.$agent.searchDownline(payload)
            .then((r) => {
               this.searchTotalRecs = r.totalRecords
               this.searchResults = r.results
               this.searching = false;     
               this.showResults = true;
            })
            .catch((err) => {
               this.searching = false; 
               this.showResults = false;
               this.$swal(
                  "Oops!",
                  "An error occured fetching your search results. Please try again later or contact support if the problem persists.",
                  "error"
               );
            })
        },
        async remoteHierarchy() {
            this.$route.params.agentNumber
            this.selectedHierarchy = this.$route.params.hier
            let h = this.$route.params.hier
            this.searching = true;
            this.showResults = false;

            let du = '' 

            if (this.$route.params.directUpline == undefined || this.$route.params.directUpline == null || this.$route.params.directUpline == "") {
               du =  h.agentNo
            } else {
               if (this.$route.params.directUpline.trim() == '0000' || this.$route.params.directUpline.trim() == '') {
                  du = h.agentNo
               } else {
                  du = this.$route.params.directUpline.trim()
               }
            }

            let payload = {
               parentAgentNumber: du,
               parentCompanyNumber: h.companyNo,
               parentBlockNumber: h.blockNo,
               lastName: null,
               firstName: null,
               agentNumber: this.$route.params.agentNumber,
               companyName: null,
               pageSize: this.searchPageSize,
               page: this.searchPage + 1
            }

            await this.$agent.searchDownline(payload)
            .then(async (r) => {
               // Fetch the hierarchy screen for the agent that was found
               if (r.results && r.results.length > 0) {
                  await this.fetchStart(r.results[0])
               } else {
                  this.$swal(
                     "Oops!",
                     "A hierarchy was not found for the selected agent. Please try again later or contact support if the problem persists.",
                     "error"
                  );
                  this.searchTotalRecs = 0
                  this.searchResults = null
                  this.searching = false;     
                  this.showResults = false;
               }
            })
            .catch((err) => {
               this.searching = false; 
               this.showResults = false;
               this.$swal(
                  "Oops!",
                  "An error occured fetching your search results. Please try again later or contact support if the problem persists.",
                  "error"
               );
            })
        },
        async runFetchStart() {
            this.$parent.loadingStart()
            this.searching = true

            await this.fetchStart()

            this.searching = false
            this.$parent.loadingEnd()
        },
        async fetchStart(item) {
            
            // Get the starting data for the hierarchy
            if (this.selectedHierarchy != null) {
               let s = this.selectedHierarchy
               let parentLvl = 1
               let agentNo = s.agentNo
               let blockNo = s.blockNo
               let companyNo = s.companyNo

               if (item) {
                  this.activateTreeTab()
                  agentNo = item.agentNumber
                  blockNo = parseInt(item.block)
                  if (item.company == '') {
                     companyNo = 0
                  } else {
                     companyNo = parseInt(item.company)
                  }
                  parentLvl = item.treeLevel
               }
               let payload = {
                  AgentNumber : agentNo,
                  CompanyNumber : companyNo,
                  BlockNumber : blockNo,
                  PageSize : this.pageSize,
                  PageNumber : this.page,
                  ParentLevels : parentLvl,
                  ChildLevels : 1
               }
               await this.$agent.getTree(payload)
               .then((r) => {
                  if (r && r.length > 0) {
                     this.selected = r[0]
                     var agentNumFound = false
                     this.setSelected(r, agentNo, agentNumFound)
                     this.$set(this, 'records', r[0])
                  } else {
                     this.noDataMsg = "None found.  Please search again..."
                     this.records = {}
                     this.searchTotalRecs = 0
                     this.searchResults = null                     

                     this.$swal(
                        `No Agent Number "${agentNo}" found`,
                        `There is no Agent Number "${agentNo}" found in this hierarchy.  Please select other hierarchies.`,
                        "warning"
                     )
                  }

                  this.nameFilter = ''
               })
               .catch((err) => {
                  // log err
               })
            }
        },
        isEmpty(obj) {
            return Object.keys(obj).length === 0
        },        
        setSelected(data, agentNo, agentNumFound) {
           data.forEach((item, index) => {            
              if (item.agentNumber==agentNo) {
                 //Once we found the Agent Number, we don't need to hide the Level Number anymore.  Anyone below him/her can show the Level Number.
                 agentNumFound = true
                 this.selected = item
                 this.selAgentLevel = parseInt(item.hierarchyLevel)
              } else {
                 if (item.children && item.children.length > 0) {
                     //Anyone above the selected level should hide the Level Number.
                     if (!agentNumFound) 
                        item.showLevel = false
                    this.setSelected(item.children, agentNo,agentNumFound)
                 }
              }
           })
        },
        async hierarchyChanged(itm, doResetShowTabs = true) {
         
         //need to go through each carrier for the selectedHierarchy agent number
         //and determine which carriers return data
         //if a carrier does not return data, then set the showRadiobtn relevant to that
         //carrier to false
         //also display the first one that returns data

           this.showResults = false
           this.selectedHierarchy = itm
           this.selectedCarrier = this.selectedHierarchy.carrier
           this.$parent.loadingStart()
           this.searching = true

           if(doResetShowTabs) { 
               await this.setHierarchyShowTabs()
           }

           await this.getDeactivated()
           this.searching = false
           this.$parent.loadingEnd()
        },
        async setHierarchyShowTabs()
        {
            var selectedAgentNumber = this.selectedHierarchy.agentNo
            this.resetHierarchyShowTabs();

            if(this.isHealthBlock(this.selectedHierarchy.blockNo))
            {
               //get an array of health carriers
               var MIACprocessed = false
               var hasData = false
               var healthHierarchies =  this.hierarchies.filter((h) => {
                 return  h.agentNo == selectedAgentNumber && this.isHealthBlock(h.blockNo)
               })

               for(let i = 0; i < healthHierarchies.length; i++)
               {
                  let h = healthHierarchies[i]
                  if((h.carrier == "MIAC" && MIACprocessed == false) || h.carrier != "MIAC")
                  {
                     await this.doesHierarchyReturnData(h)
                     if(h.carrier == "MIAC")
                     {
                        MIACprocessed = true
                     }
                  }
               }
            }
            else 
            {
               //get an array of life carriers
               var lifeHierarchies =  this.hierarchies.filter((h) => {
                 return  h.agentNo == selectedAgentNumber && !this.isHealthBlock(h.blockNo)
               })

               for(let i = 0; i < lifeHierarchies.length; i++)
               {
                  let h = lifeHierarchies[i]
                  await this.doesHierarchyReturnData(h)
               }
            }
            //if there is Hierarchy tab content to show
            if(this.showActiveAgentsTabContent())
            {
               this.setRecordsInfo()
            }
        },
        async doesHierarchyReturnData(hierarchy)
        {
            var h = hierarchy
            let payload = {
                  AgentNumber : h.agentNo,
                  CompanyNumber : h.companyNo,
                  BlockNumber : h.blockNo,
                  PageSize : this.pageSize,
                  PageNumber : this.page,
                  ParentLevels : 1,
                  ChildLevels : 1
               }

            var result = await this.$agent.getTree(payload)
               .then((r) => {
                  if (r && r.length > 0) {
                     this.setCarrierRecordsInfo(r, h.carrier, h.blockNo)
                     return true
                  } else {
                     return false
                  }
               })
               .catch((err) => {
                  // log err
                  console.log(`doesHierarchyReturnData() error`)
                  return false
               })
            return result
        },
        setCarrierRecordsInfo(treeDataList, carrier, blockNo)
        {
            if(this.isHealthBlock(blockNo))
            {
               switch(carrier)
               {
                  case "MIAC":
                     this.miacHealthTreeData = treeDataList
                     this.showMiacHealthTab = true
                     break;
                  case "SLAC":
                     this.slacHealthTreeData = treeDataList
                     this.showSlacHealthTab = true
                     break;
               }
            }
            else {

               switch(carrier)
               {
                  case "SLAC":
                     this.slacLifeTreeData = treeDataList
                     this.showSlacLifeTab = true
                     break;
               }
            }
        },
        setRecordsInfo()
        {
            var treeRecords = null
            //need to call set seleted and $set after hierarchy has changed
            //have to determine which tab is going to display as the default
            //this will be based upon the showTab boolean values

            if(this.isHealthBlock(this.selectedHierarchy.blockNo)) { 
               
               //process health
             
               if(this.showMiacHealthTab) {
                  treeRecords = this.miacHealthTreeData
               }
               else {
                  if (this.showSlacHealthTab) {
                     treeRecords = this.slacHealthTreeData
                  }
               }

            }
            else {
               // process life 
               if(this.showSlacLifeTab) {
                  treeRecords = this.slacLifeTreeData
               }
            }

            var agentNo = this.selectedHierarchy.agentNo
            this.selected = treeRecords[0]
            var agentNumFound = false

            this.setSelected(treeRecords, agentNo, agentNumFound)
            this.$set(this, 'records', treeRecords[0])
        },
        resetHierarchyShowTabs()
        {
            this.showMiacHealthTab = false
            this.showSlacHealthTab = false            
            this.showSlacLifeTab = false

            this.miacHealthTreeData = []
            this.slacHealthTreeData = []
            this.slacLifeTreeData = []
        },
        handleCarrierTabClicked(carrier)
        {
            var treeDataList = []
            if(this.isHealthBlock(this.selectedHierarchy.blockNo))
            {
               switch(carrier)
               {
                  case "MIAC":
                     treeDataList = this.miacHealthTreeData
                     break;
                  case "SLAC":
                     treeDataList = this.slacHealthTreeData
                     break;
               }
            }
            else {
               switch(carrier)
               {
                  case "SLAC":
                     treeDataList = this.slacLifeTreeData
                     break;
               }
            }
          
            var agentNo = this.selectedHierarchy.agentNo
            this.selected = treeDataList[0]
            var agentNumFound = false
            this.setSelected(treeDataList, agentNo, agentNumFound)
            this.$set(this, 'records', treeDataList[0])
        },
        deactPageChanged(newCount) {
            this.$parent.loadingStart()
            this.searching = true

            this.deactPageSize = parseInt(newCount)
            this.getDeactivated()

            this.searching = false
            this.$parent.loadingEnd()
        },
        deactGridNavHandler: function(command) {
            switch(command) {
                case 'FIRST':
                    this.deactPage = 0
                    break;
                case 'PREVIOUS':
                    this.deactPage--
                    break;
                case 'NEXT':
                    this.deactPage++
                    break;
                case 'LAST':
                    this.deactPage = this.deactTotalPages - 1
                    break;
            }
            this.getDeactivated()
        },
        deactHasData() {
            if (this.deactAgents != null) {
                return this.deactAgents.length > 0
            }
            return false
        },
        searchPageChanged(newCount) {
            this.searchPage = 0
            this.searchPageSize = parseInt(newCount)
            this.search()
        },
        searchHasData() {
            if (this.searchResults != null) {
                return this.searchResults.length > 0
            }
            return false
        },
        searchGridClickHandler: function(item) {
            let agt = {
               agentNumber: item.agentNumber,
               blockNumber: item.block,
               companyName: item.companyName,
               companyNumber: item.company,
               directUpline: item.directUpline,
               firstName:  item.firstName,
               mgaCode: item.mgaCode,
               hierarchyLevel: item.hierarchyLevel,
               lastName: item.lastName,
               topAgentNum: this.selectedHierarchy.agentNo
            }
            this.goToAgentDetail(agt);
        },
        async searchGridHierHandler(item) {
            this.$parent.loadingStart()
            this.searching = true

            await this.fetchStart(item)

            this.searching = false
            this.$parent.loadingEnd()
        },
        searchGridNavHandler: function(command) {
            switch(command) {
                case 'FIRST':
                    this.searchPage = 0
                    break;
                case 'PREVIOUS':
                    this.searchPage--
                    break;
                case 'NEXT':
                    this.searchPage++
                    break;
                case 'LAST':
                    this.searchPage = this.searchTotalPages - 1
                    break;
            }
            this.search()
        },
        activateTreeTab(){
            $("#tree_tab").tab('show')
        },
        async handleCarrierChange()
        {
            var agentNumber = this.selectedHierarchy.agentNo
            var item = this.hierarchies.filter((h) => { return h.agentNo == agentNumber && h.carrier == this.selectedCarrier})[0]
            await this.hierarchyChanged(item, false)
        },
        showActiveAgentsTabContent() {
           var returnVal = this.showMiacHealthTab || this.showSlacHealthTab || this.showSlacLifeTab
           return returnVal
        },
        activateShowHierarchyCarrierTab(carrier)
        {
            if(this.isHealthBlock(this.selectedHierarchy.blockNo))
            {
               if(carrier == 'SLAC') {
                  if(this.showSlacHealthTab) {
                     if(!this.showMiacHealthTab) {
                        return true
                     }
                  }
                  else {
                     return false
                  }
               }
            }
            else {
               //process life tabs
               if(carrier == 'SLAC') {

                  if(this.showSlacLifeTab) {
                     return true
                  }
                  else {
                     return false
                  }
               }
            }

            return false
        }
    }
}
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
// @import "../assets/css/site.scss";
.filter-btn {
   max-width: 40px !important;
   min-width: 40px;
   width: 40px !important;
   padding: 0px;
   background-color: #fff;
   color: #000;
   border: 1px solid #ccc;
}
.filter-btn:hover {
   background-color: $corp-color;
   color: #fff;
   border-width: 0;
}
.hier-btn {
   background-color: transparent;
   outline: none;
   width: 100%;
   border: 1px solid #ccc;
   border-radius: 3px;
   margin: 0;
}
.hier-ctn {
   width: 100%;
   border: 1px solid #ccc;
   border-radius: 3px;
   margin: 0;
   padding: 0;
}
.hiera {
   line-height:24px;
   border-width: 0 1px 1px 1px;
   border-style: solid;
   border-color: #ccc;
}
.tab-content {
   padding: 12px;
   min-height: 475px;
}
.reset-link, .reset-link.visited {
   float: right;
   font-size: small;
   text-decoration: none;
}
.reset-link:hover {
   color: #000;
   text-decoration: none;
}
.tab-box {
   position: relative;
}
.req-link {
   position: absolute;
   right: 40px;
   top: 6px;
}
.card-label {
   margin-left: 6px;
}
.not-found-text {
   font-size: small;
   padding: 4px 8px;
}
.font-smaller {
   font-size: smaller;
}
</style>